import { render, staticRenderFns } from "./Rolodex.vue?vue&type=template&id=a18a4a76&scoped=true"
import script from "./Rolodex.vue?vue&type=script&lang=js"
export * from "./Rolodex.vue?vue&type=script&lang=js"
import style0 from "./Rolodex.vue?vue&type=style&index=0&id=a18a4a76&prod&lang=scss&scoped=true"
import style1 from "./Rolodex.vue?vue&type=style&index=1&id=a18a4a76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a18a4a76",
  null
  
)

export default component.exports